// @flow
import * as React from 'react';
import classNames from 'classnames';
import isEqual from 'react-fast-compare';
import styles from './PageTitle.module.scss';

type Props = {
    className?: string,
    title: React.Node,
};

const PageTitle = (props: Props) => {
    const { className, title } = props;
    const classes = classNames(styles.title, className);
    if (!title) return null;
    return <h1 className={classes}>{title}</h1>;
};

export default React.memo<Props>(PageTitle, isEqual);
